var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex",on:{"click":function($event){return _vm.showReportDetail()}}},[_vm._m(0),_c('p',{staticClass:"table-text"},[_vm._v(_vm._s(_vm.$t('maintenance_report.see-detail')))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"mx-2",attrs:{"src":require("@/assets/view-detail.svg"),"alt":"view-detail"}})])
}]

export { render, staticRenderFns }